var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ig-iframe-box"},[_c('iframe',{style:({height:_vm.height}),attrs:{"id":"ig-iframe","scrolling":"no","name":"iframe","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }